<template lang="pug">
.mx-auto.max-w-home-hero-container
  form(@submit.prevent="onSubmit")
    .bg-red-50.border.border-red-200.rounded-lg.p-4.mb-6(v-if="Object.keys(errors).length" class="border-l-4 border-l-red-400")
      .flex.items-start
        i.fas.fa-exclamation-triangle.text-red-400.mt-1.mr-3
        div
          h4.text-red-800.font-600.mb-2 Erreur dans le formulaire
          form-error(:errors="errors")

    .grid.grid-cols-1.gap-6.mb-6(class="lg:grid-cols-2 lg:mb-8" style="lg:gap: 37px;")
      .form-group
        label.block.text-base.font-500.text-tertiary.mb-2.text-left(for="contact_firstname") Prénom*
        input#contact_firstname.w-full.px-4.py-3.border.rounded-10.focus_border-primary.focus_ring-2.focus_ring-primary.focus_ring-opacity-20.transition-all.duration-200(style="border-color: rgba(107, 114, 128, 0.1);"
          v-model="contact.firstname"
          type="text"
          required="required"
          placeholder="Votre prénom"
          :class="{'border-red-400 focus:border-red-400 focus:ring-red-200': errors.firstname}"
        )

      .form-group
        label.block.text-base.font-500.text-tertiary.mb-2.text-left(for="contact_lastname") Nom*
        input#contact_lastname.w-full.px-4.py-3.border.rounded-10.focus_border-primary.focus_ring-2.focus_ring-primary.focus_ring-opacity-20.transition-all.duration-200(style="border-color: rgba(107, 114, 128, 0.1);"
          v-model="contact.lastname"
          type="text"
          required="required"
          placeholder="Votre nom"
          :class="{'border-red-400 focus:border-red-400 focus:ring-red-200': errors.lastname}"
        )

    .grid.grid-cols-1.gap-6.mb-6(class="lg:grid-cols-2 lg:mb-14" style="lg:gap: 37px;")
      .form-group
        label.block.text-base.font-500.text-tertiary.mb-2.text-left(for="contact_email") Email*
        input#contact_email.w-full.px-4.py-3.border.rounded-10.focus_border-primary.focus_ring-2.focus_ring-primary.focus_ring-opacity-20.transition-all.duration-200(style="border-color: rgba(107, 114, 128, 0.1);"
          v-model="contact.email"
          type="email"
          required="required"
          placeholder="Votre email"
          :class="{'border-red-400 focus:border-red-400 focus:ring-red-200': errors.email}"
        )

      .form-group
        label.block.text-base.font-500.text-tertiary.mb-2.text-left(for="contact_phone") Téléphone*
        .flex
          .px-3.py-3.border.rounded-l-10.bg-white.flex.items-center.text-sm(class="lg:px-4 lg:text-base" style="border-color: rgba(107, 114, 128, 0.1);")
            span.text-xs(class="lg:text-sm") 🇫🇷 +33
          input#contact_phone.flex-1.px-4.py-3.border.border-l-0.rounded-r-10.bg-white.focus_border-primary.focus_ring-2.focus_ring-primary.focus_ring-opacity-20.transition-all.duration-200(
            v-model="contact.phone"
            type="tel"
            required="required"
            placeholder="Votre numéro de tél."
            style="border-color: rgba(107, 114, 128, 0.1);"
            :class="{'border-red-400 focus:border-red-400 focus:ring-red-200': errors.phone}"
          )

    .form-group.mb-6(class="lg:mb-14")
      h3.text-base.font-600.text-tertiary.mb-4.text-center Préférences pour vous contacter :
      .flex.justify-center.gap-4.flex-wrap(class="lg:gap-8")
        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="email"
            v-model="contact.contact_preference"
            name="contact_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.contact_preference === 'email'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.contact_preference === 'email'")
          span.text-base.font-500.text-tertiary E-mail

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="whatsapp"
            v-model="contact.contact_preference"
            name="contact_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.contact_preference === 'whatsapp'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.contact_preference === 'whatsapp'")
          span.text-base.font-500.text-tertiary WhatsApp

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="sms"
            v-model="contact.contact_preference"
            name="contact_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.contact_preference === 'sms'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.contact_preference === 'sms'")
          span.text-base.font-500.text-tertiary SMS

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="téléphone"
            v-model="contact.contact_preference"
            name="contact_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.contact_preference === 'téléphone'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.contact_preference === 'téléphone'")
          span.text-base.font-500.text-tertiary Téléphone

    .form-group.mb-6(class="lg:mb-14")
      h3.text-base.font-600.text-tertiary.mb-4.text-center Horaires pour vous contacter :
      .flex.justify-center.gap-4.flex-wrap(class="lg:gap-8")
        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="matin"
            v-model="contact.time_preference"
            name="time_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.time_preference === 'matin'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.time_preference === 'matin'")
          span.text-base.font-500.text-tertiary Matin

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="midi"
            v-model="contact.time_preference"
            name="time_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.time_preference === 'midi'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.time_preference === 'midi'")
          span.text-base.font-500.text-tertiary Midi

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="soir"
            v-model="contact.time_preference"
            name="time_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.time_preference === 'soir'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.time_preference === 'soir'")
          span.text-base.font-500.text-tertiary Soir

        label.flex.items-center.cursor-pointer.gap-3
          input.sr-only(
            type="radio"
            value="pas de préférence"
            v-model="contact.time_preference"
            name="time_preference"
          )
          .w-6.h-6.border-2.border-primary.rounded-full.flex.items-center.justify-center.transition-colors.duration-200(
            :class="{'bg-primary': contact.time_preference === 'pas de préférence'}"
          )
            .w-2.h-2.bg-white.rounded-full(v-if="contact.time_preference === 'pas de préférence'")
          span.text-base.font-500.text-tertiary Pas de préférences

    .flex.items-start.gap-3.text-sm.text-tertiary.text-opacity-50.leading-relaxed.text-left.mb-6(class="lg:mb-4")
      input#rgpd_terms(
        type="checkbox"
        v-model="contact.rgpd_terms_accepted"
        required
        class="mt-1"
        style="border-color: rgba(107, 114, 128, 0.1);"
      )
      label.flex-1(for="rgpd_terms")
        | En soumettant ce formulaire, j'accepte que les informations saisies dans ce formulaire soient utilisées, exploitées,
        | traitées pour permettre de me recontacter. Découvrez comment nous recueillons, utilisons et partageons vos
        | données en lisant notre politique d'utilisation des données.
    button.btn.btn-rounded.btn-arrow.min-w-btn.text-left.duration-150.bg-tertiary.mx-auto.cursor-pointer.mt-12.mb-3(
      type="submit"
      :id="submitButtonId"
    )
      span.btn-label.text-sable(class="group-hover:duration-0 group-hover:transition-none")
        | Valider ma demande
      svg.h-10.ml-4.text-primary(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24")
        g(clip-path="url(#a)")
          circle(cx="12" cy="12" r="12" fill="currentColor" class="transition duration-150 group-hover:text-white")
          g(clip-path="url(#b)")
            path.text-white.group-hover_text-primary(fill="currentColor" d="M19.8 12.6v-.1l.2-.2-.2-.2.1-.2c.1-.1.1-.3 0-.4l-.1-.3-.2.1-.1-.1h-.1L17.1 10l-2.3-1.5c-1-.6-1.9-1.2-2.6-2h-.1l-.1.1h-.2l-.2.1c0 .1-.1.3 0 .4l.1.5.2.3.7.8.9.7 1.2.8 1 .8-.6-.1-1.8-1.3-1.2-1-.5-.7c-.2 0-.2.1-.1.3l.1.3.8.8 2.3 1.5c-1.8-.2-3.7 0-5.4.3a12 12 0 0 0-3.2 1.2c-.6.3-1 .6-1.5 1.1l-.6.9c-1.1 1.6 1.7.2 4-.6l.4-.1.3-.2.8-.2a25.6 25.6 0 0 1 7.1-.2h-.1l-2.4 1.3-2.6 1.3-.2.1c-.1.1-.1.3 0 .4v.2l-.3.2.2.2v.1c0 .2 0 .3.2.5h.6l-.2.2h.4l1.8-1.4.3-.2 2-1.1a46.8 46.8 0 0 0 2.3-1.3l.2.2-1 .6-2.2 1.2c-.3.3-.7.4-1 .6l-2 1.2-.9.5c0 .2.2.1.2 0 .3 0 .6-.2 1-.4l2-1.2 1.3-.7 2.6-1.4.8-.8.3-.3c0-.1 0-.2-.2-.3Zm-14.6 2 .2-.2-.2.2Zm3-1.5-.8.2c-.1.2-.3.2-.5.2l-.1.2-1.2.7h-.1c.4-.4.9-.6 1.4-.8.2-.2.3-.3.5-.3l.8-.2c.2-.2.3-.2.6-.2a1 1 0 0 1-.6.2Zm.6-.2c.1-.1.2-.1.4 0h-.4Zm1.8-.4-.6.2.6-.2h.4-.4Zm.6 0 .3-.1h-.3Zm1-.1H12h.3Zm1.9 0h.4-.4Zm3.6 0-.1-.1h.2-.1Zm-3 0h.6-.5Zm2.1.3-1.2-.2h-.2l.2-.1.9.1.7.1-.2.1h-.2Zm2.5.6-.2.2-.3-.2h.4L19 13l.2-.1h.3l-.2.3Z")
        defs
          clipPath(id="a")
            path.text-white.group-hover_text-primary(fill="currentColor" d="M0 0h24v24H0z")
          clipPath(id="b")
            path.text-white.group-hover_text-primary(fill="currentColor" d="M3.4 4H20v16.6H3.4z")
    vue-recaptcha(
      ref="recaptcha"
      size="invisible"
      :sitekey="recaptchaAppKey"
      @verify="onCaptchaVerify"
      @expired="onCaptchaExpired"
    )
</template>

<script>
import FormError from '@components/FormError'
import axios from 'axios'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'ProgramContactForm',

  components: {
    VueRecaptcha,
    FormError
  },

  props: {
    recaptchaAppKey: {
      type: String,
      required: true
    },

    redirectOnSubmit: {
      type: String,
      default: '/contacts'
    },

    contactable: {
      type: Object,
      default () { return {} }
    },

    programTitle: {
      type: String,
      default: 'la résidence'
    },

    submitButtonId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      contact: {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        country_code: '+33',
        message: 'Demande d\'information concernant la résidence ' + this.programTitle,
        subject: '',
        contactable_type: this.contactable.contactable_type,
        contactable_id: this.contactable.contactable_id,
        rgpd_terms_accepted: false,
        contact_preference: '',
        time_preference: '',
        url: window.location.href
      },
      errors: {},
      isSubmitting: false,
      showPrivacyModal: false
    }
  },

  computed: {
    canSubmit () {
      return !!(
        this.contact.firstname &&
        this.contact.lastname &&
        this.contact.phone &&
        this.contact.email &&
        this.contact.contact_preference &&
        this.contact.time_preference &&
        this.contact.rgpd_terms_accepted
      )
    },

    fullPhoneNumber () {
      return this.contact.country_code + this.contact.phone
    }
  },

  methods: {
    scrollToForm () {
      if (!this.canSubmit) {
        this.errors = {
          base: ['Veuillez remplir tous les champs, sélectionner une préférence de contact, un horaire et accepter les conditions RGPD']
        }
        return
      }

      this.onSubmit()
    },

    onSubmit () {
      if (!this.canSubmit) {
        this.errors = {
          base: ['Veuillez remplir tous les champs, sélectionner une préférence de contact, un horaire et accepter les conditions RGPD']
        }
        return
      }

      this.$refs.recaptcha.execute()
    },

    onCaptchaVerify (recaptchaToken) {
      this.isSubmitting = true
      this.$refs.recaptcha.reset()
      this.errors = {}

      const contactData = {
        ...this.contact,
        phone: this.fullPhoneNumber,
        contact_preferences: this.contact.contact_preference,
        time_preferences: this.contact.time_preference
      }

      axios.post('/api/v1/contacts', {
        contact: contactData,
        'g-recaptcha-response': recaptchaToken
      })
        .then(() => {
          this.showSuccessMessage()

          setTimeout(() => {
            window.location.href = this.redirectOnSubmit
          }, 2000)
        })
        .catch(({ response: { data } }) => {
          this.isSubmitting = false
          this.errors = data.errors?.data?.attributes?.errors || { base: ['Une erreur est survenue'] }

          this.$nextTick(() => {
            const errorElement = this.$el.querySelector('.bg-red-50')
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        })
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      this.isSubmitting = false
    },

    showSuccessMessage () {
      const button = this.$el.querySelector('button[type="button"]')
      if (button) {
        button.innerHTML = `
          <i class="mr-3 fas fa-check text-primary"></i>
          Demande envoyée !
        `
        button.classList.add('bg-green-500', 'cursor-not-allowed')
        button.classList.remove('bg-tertiary', 'hover:shadow-xl')
        button.disabled = true
      }
    }
  }
}
</script>

<style scoped>
.form-group {
  transition: all 0.2s ease-in-out;
}

input:focus,
select:focus {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bg-gray-50 {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

label:hover .w-5 {
  transform: scale(1.05);
}
</style>
